import { useAuthStore } from '@/hooks'
import { Role } from '@/constants/role'
import { PID_GROUP } from '@/comm'

export const useRole = (role, strict) => {
  const userRoles = useAuthStore((state) => state.auth?.user?.roles || [])
  if (strict) return userRoles.includes(role)
  return userRoles?.includes(Role.Admin) || userRoles?.includes(role)
}

export const useRoles = (roles) => {
  const userRoles = useAuthStore((state) => state.auth?.user?.roles || [])
  const isAdmin = userRoles?.includes(Role.Admin)
  const isRole = roles.some((role) => userRoles.includes(role))
  return isAdmin || isRole
}

export const useReadableEr = (pid, country) => {
  const reads = useAuthStore(
    (state) => state.auth?.user?.prReadable?.split(',') || [],
  )
  return isReadable(reads, pid, country)
}

export const useReadableRoas = (pid, country) => {
  const reads = useAuthStore(
    (state) => state.auth?.user?.roasReadable?.split(',') || [],
  )
  return isReadable(reads, pid, country)
}

export const useReadableCost = (pid, country) => {
  const reads = useAuthStore(
    (state) => state.auth?.user?.mediaBuyReadable?.split(',') || [],
  )
  return isReadable(reads, pid, country)
}

export const useReadableRevenue = (pid, country) => {
  const reads = useAuthStore(
    (state) => state.auth?.user?.revenueReadable?.split(',') || [],
  )
  return isReadable(reads, pid, country)
}

// 与服务端 guard/readables.guard.ts 的 isPidAccess 保持一致
const STICKER_GROUP_CODES = new Set(['total1', 'total1_1', 'total1_2'])

const isPidAccess = (pCode, pid) => {
  if (pCode === '*' || pCode === pid) return true
  if (PID_GROUP[pCode]?.includes(pid)) return true
  // sticker 分组权限可互读兄弟 / 父分组的聚合行
  return STICKER_GROUP_CODES.has(pCode) && STICKER_GROUP_CODES.has(pid)
}

const isCountryAccess = (cCode, country) => {
  return cCode === '*' || cCode === country
}

export const isReadable = (reads, pid, country) => {
  return reads.some((r) => {
    const [p, c] = r.split('-')
    return isPidAccess(p, pid) && isCountryAccess(c, country)
  })
}

export const computeRead = (reads, pcode) => {
  const isExists = reads.includes(pcode)
  let result

  if (isExists) {
    // 如果找到了，则从数组中移除
    result = reads.filter((item) => item !== pcode)
  } else {
    // 如果没找到，则直接复制 reads 数组
    result = [...reads]
    result.push(pcode)
  }
  // 将结果拼接成字符串
  return result.filter((i) => i !== '').join(',')
}
